import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuthToken from "../services/AuthToken";

const PrivateRoute = ({ children }) => {
  const isTokenPresent = useAuthToken();

  if (isTokenPresent === null) {
    return <div>Loading...</div>; // Prevent premature redirection
  }

  return isTokenPresent ? children : <Navigate to="/login" />;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
